import React, { PureComponent } from 'react';
import { Router, withRouter } from 'react-router'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Provider } from 'react-redux'
import createHistory from 'history/createBrowserHistory'
import store from './state'
import { Tooltip } from 'redux-tooltip';
import { connect } from 'react-redux'

//pages
import DataExplorer from './pages/DataExplorer'
import ThirdPillar from './pages/ThirdPillar'
import CountryFacilitationPolicies from './pages/CountryFacilitationPolicies'
import SevenPillars from './pages/SevenPillars'

import { loadTfaArticles } from './state/actions'

const mapDispatchToProps = { loadTfaArticles }
const mapStateToProps = (state) => {
  return {
    modalOpen: state.modalOpen
  }
}

const Routes = connect(mapStateToProps, mapDispatchToProps)(class extends React.PureComponent {

  componentWillMount(){
    //this.props.loadTfaArticles()
  }

  render() {
    const { location, modalOpen } = this.props
    return (
      <div className={`blue-background ${modalOpen ? 'noscroll' : ''}`}>
        <Tooltip className="tooltip-with-width"/>

        {/* <CSSTransitionGroup
          component="div"
          transitionName="fade"
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}> */}

          <Switch key={location.key} location={location}>
            {/* <Route path="/" component={DataExplorer}/> */}
            <Route path="/third-pillar/:countryCode?" component={ThirdPillar}/>
            <Route path="/trade-facilitation-policies" component={CountryFacilitationPolicies}/>
            <Route path="/enabling-trade-environment" component={SevenPillars}/>
            <Redirect from="/" to="/third-pillar"/>
            {/* <Route path="/" component={DataExplorer}/> */}
          </Switch>

        {/* </CSSTransitionGroup> */}

      </div>
    )
  }
})

const history = createHistory()

class ScrollToTopNoRouter extends PureComponent {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}
const ScrollToTop = withRouter(ScrollToTopNoRouter)

const App = () => (
  <Provider store={store}>
    <Router history={history}>
      <ScrollToTop>
        <Route component={Routes}/>
      </ScrollToTop>
    </Router>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js